import { createAuthClient } from 'better-auth/react';
import { anonymousClient, emailOTPClient } from 'better-auth/client/plugins';

/**
 * Клиент Better Auth. baseURL не задаётся: приложение и API живут на одном
 * origin (Worker отдаёт и статику, и /api), поэтому относительные пути верны
 * и в разработке через прокси Vite, и в проде.
 *
 * ВАЖНО: гость привязывается через signIn.social и signIn.emailOtp, а НЕ через
 * linkSocial - хук привязки в ядре срабатывает на путях /sign-in/*, /callback/*
 * и /email-otp/verify-email, но не на /link-social.
 */
export const authClient = createAuthClient({
  plugins: [anonymousClient(), emailOTPClient()],
});

export type AuthSession = typeof authClient.$Infer.Session;
